import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.module.css';

type HRuleProps = {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

export const HRule: FC<HRuleProps> = ({ className, size = 'sm' }) => {
  return <hr className={classNames(styles.hrule, styles[size], className)} />;
};
